import EvaluateProcessor from "../../../../core/internal/evaluation/EvaluateProcessor"
import { HackleUser } from "../../../../core/internal/model/model"
import { InAppMessageEligibilityLocalEvaluateRequest } from "../../../../core/internal/evaluation/service/inappmessage/eligibility/mode/local/InAppMessageEligibilityLocalEvaluateRequest"
import { InAppMessageLayoutLocalEvaluateRequest } from "../../../../core/internal/evaluation/service/inappmessage/layout/mode/local/InAppMessageLayoutLocalEvaluateRequest"
import WorkspaceConfigFetcher from "../../../../core/internal/workspace/config/WorkspaceConfigFetcher"
import { InAppMessageDeliverRequest } from "../InAppMessageDeliverRequest"
import { InAppMessageDeliverEvaluateResponse } from "./InAppMessageDeliverEvaluateResponse"
import { InAppMessageDeliverEvaluation } from "./InAppMessageDeliverEvaluation"
import { InAppMessageDeliverEvaluator } from "./InAppMessageDeliverEvaluator"

export class InAppMessageDeliverLocalEvaluator implements InAppMessageDeliverEvaluator {
  constructor(
    private readonly workspaceFetcher: WorkspaceConfigFetcher,
    private readonly evaluateProcessor: EvaluateProcessor
  ) {}

  async evaluate(request: InAppMessageDeliverRequest, user: HackleUser): Promise<InAppMessageDeliverEvaluateResponse> {
    const workspace = this.workspaceFetcher.workspace(user)
    if (!workspace) {
      return InAppMessageDeliverEvaluateResponse.ineligible("WORKSPACE_NOT_FOUND")
    }

    const inAppMessage = workspace.getInAppMessageOrNull(request.inAppMessageKey)
    if (!inAppMessage) {
      return InAppMessageDeliverEvaluateResponse.ineligible("IN_APP_MESSAGE_NOT_FOUND")
    }

    const layout = this.evaluateProcessor.inAppMessageLayout(
      new InAppMessageLayoutLocalEvaluateRequest(workspace, user, inAppMessage, "DELIVER")
    )

    const eligibility = this.evaluateProcessor.inAppMessageEligibility(
      new InAppMessageEligibilityLocalEvaluateRequest(workspace, user, inAppMessage, "DELIVER", "WEB", request.requestedAt)
    )

    return InAppMessageDeliverEvaluateResponse.of(new InAppMessageDeliverEvaluation(eligibility, layout))
  }
}
